import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Index from "./pages/Index";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import BrowseListings from "./pages/BrowseListings";
import SubscriptionPage from "./pages/SubscriptionPage";
import ReferralSubmission from "./pages/ReferralSubmission";
import ProfileSettings from "./pages/ProfileSettings";
import SupportPage from "./pages/SupportPage";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NotFound from "./pages/NotFound";
import OnboardingPage from "./pages/OnboardingPage";
import LogoProcessingPage from "./pages/LogoProcessingPage";
import ProductionTestingPage from "./pages/ProductionTestingPage";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/browse" element={<BrowseListings />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route
              path="/subscription"
              element={
                <ProtectedRoute allowedRoles={['provider']}>
                  <SubscriptionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/referral/:listingId"
              element={
                <ProtectedRoute allowedRoles={['case_manager', 'social_worker', 'discharge_planner', 'housing_stabilization_worker']}>
                  <ReferralSubmission />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfileSettings />
                </ProtectedRoute>
              }
            />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/logo-processing" element={<LogoProcessingPage />} />
            <Route
              path="/production-testing"
              element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <ProductionTestingPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;